<template>
  <div>
    <v-container fluid grid-list-sm v-if="!editingNotAllowed">
      <v-layout justify-space-between row wrap>
        <v-flex v-for="(item, i) in informations" :key="i" :class="item.class">
          <v-list three-line light class="py-0 elevation-2" >
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="font-weight-bold">{{item.title}}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{item.subtitle}}</v-list-tile-sub-title>
                <v-list-tile-sub-title>{{item.value | currency}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
      <v-layout justify-space-between row wrap>
        <v-flex xs12 v-if="!budgetFinalized">
          <v-alert class="mt-2" :value="true" type="warning" dismissible v-if="hasBond" icon="priority_high" outline style="font-size: 18px !important">
            <strong>Atenção!</strong> Existem outros anexos vínculados à este!
          </v-alert>
          <v-btn color="green" block large dark @click="openBondDialog" v-else-if="!moduleFive[this.attachment].bond">Vincular à outro Anexo</v-btn>
          <v-btn color="green" block large dark @click="unbondDialog = true" v-else>Desvincular</v-btn>
        </v-flex>
        <v-flex xs12 v-if="moduleFive[this.attachment].bond != ''">
          <v-alert v-model="bondAlert" type="warning" dismissible
            icon="priority_high" outline style="font-size: 18px !important">
            <strong>Atenção!</strong> Este anexo está vinculado à <strong>{{bondSheetDescription}}</strong>, clique no botão acima para desvincular.
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout justify-space-between row wrap>
        <v-flex xs12>
          <v-card class="mt-2 pt-2 elevation-3">
            <v-layout justify-space-between wrap px-3>
              <v-radio-group label="Forma de Cálculo:" v-model="depreciation" row :readonly="budgetFinalized">
                <v-radio label="Taxa de Depreciação (%)" value="true" class="ml-3"></v-radio>
                <v-radio label="Vida Útil (mês)" value="false" class="ml-3"></v-radio>
              </v-radio-group>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="!moduleFive[this.attachment].bond">
        <v-flex xs12 v-if="!budgetFinalized">
          <v-card v-if="show" class="mt-2 elevation-3">
            <v-layout justify-space-between wrap pa-3>
              <v-spacer />
              <v-icon @click="show = !show; input = {}">close</v-icon>
            </v-layout>
            <v-form v-model="validForm" ref="form" lazy-validation>
              <v-layout justify-space-between wrap px-3>
                <v-flex xs12 md4 py-0>
                  <v-autocomplete :items="filteredInputs" box :item-text="textDescription" :item-value="textDescription" v-model="input" label="Descrição / Especificação"
                    return-object :rules="inputRules"></v-autocomplete>
                </v-flex>
                <v-flex xs12 md2 py-0>
                  <v-text-field box v-model="input.unity" label="Unidade" title="Unidade" disabled :rules="inputRules"></v-text-field>
                </v-flex>
                <v-flex xs12 md2 py-0>
                  <v-text-field v-model="input.quantity" label="Quantidade" box type="number" :rules="inputRules"></v-text-field>
                </v-flex>
                <v-flex xs12 md2 py-0>
                  <v-text-field box v-model="input.lifetime" :label="labelDepreciation" type="number" :rules="inputRules"></v-text-field>
                </v-flex>
                <v-flex xs12 md2 py-0>
                  <v-currency-field 
                    box
                    label="Valor Unitário (R$)" 
                    v-bind="currency_config"
                    v-model="input.value"
                    :rules="inputRules">
                  </v-currency-field>
                </v-flex>
                <v-flex xs12 md2 offset-md10 py-0>
                  <v-btn color="success lighten-1"  large @click.stop.prevent="save();" block>Salvar</v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card>
        </v-flex>
        <v-flex xs12 pt-4>
          <!-- TOOBAR MAIN -->
          <v-toolbar flat card color="grey lighten-3" class="elevation-1">
            <v-toolbar-title class="font-weight-light">Itens Selecionados</v-toolbar-title>
            <v-spacer />
            <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
            <v-spacer />
            <v-toolbar-items>
              <v-btn  slot="activator" color="info" round icon class="mb-2"
                @click="show = !show" v-if="!budgetFinalized">
                <v-icon>add</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <!-- TABELA -->
          <v-data-table :headers="headers" :search="search" rows-per-page-text="Registros por Página" :rows-per-page-items="[10, 30, 50, 100]"
            :items="selectedItems" class="elevation-1">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.description }}</td>
              <td class="text-xs-center">{{ props.item.unity }}</td>
              <td class="text-xs-center">{{ props.item.quantity }}</td>
              <td class="text-xs-center">{{ props.item.value | currency }}</td>
              <td class="text-xs-center">{{ (props.item.value * props.item.quantity) | currency}}</td>
              <td class="text-xs-center">{{ props.item.lifetime }} {{depreciation == "true" ? " %" : " (meses)"}}</td>
              <td class="text-xs-center">{{ amountCalculate(props.item) | currency}}</td>
              <td class="text-xs-center" v-if="!budgetFinalized">
                <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                <v-icon small @click="openRemoveDialog(props.item)">delete</v-icon>
              </td>
              <td class="text-xs-center" v-else> - </td>
            </template>
            <template slot="pageText" slot-scope="props">
              {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
            </template>
            <template slot="no-data">
              <strong> {{footerDynamicText}} </strong>
            </template>
            <div slot="no-results" :value="true">
              <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
            </div>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- TOTAIS -->
    
    <!-- Confirmação de remoção de itens -->
    <v-dialog v-model="removeDialog" persistent :overlay="true" max-width="500px" transition="dialog-transition">
      <v-toolbar class="elevation-1" card>
        <v-toolbar-title class="font-weight-light">
          {{removeDialogTitle}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="error" title="Cancelar" icon round flat @click.stop.prevent="removeDialog = false">
            <v-icon large>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <p>Tem certeza que deseja excluir este item?</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" class="mb-3" block outline round @click="deleteItem">Aceitar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmação de remoção do vinculo -->
    <v-dialog v-model="unbondDialog" persistent :overlay="true" max-width="500px" transition="dialog-transition">
      <v-toolbar class="elevation-1" card>
        <v-toolbar-title class="font-weight-light">
          Remover Vínculo
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="error" title="Cancelar" icon round flat @click.stop.prevent="unbondDialog = false">
            <v-icon large>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <p>Tem certeza que deseja remover o vínculo?</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" class="mb-3" block outline round @click="unbond">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmação de vínculo de anexo -->
    <v-dialog v-model="bondDialog" persistent :overlay="true" max-width="500px" transition="dialog-transition">
      <v-toolbar class="elevation-1" card>
        <v-toolbar-title class="font-weight-light">
          {{bondDialogTitle}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="error" title="Cancelar" icon round flat @click.stop.prevent="bondDialog = false; sheetBondId=null">
            <v-icon large>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <p>Tem certeza que deseja vincular este anexo?</p>
          <p class="red--text">Uma vez vinculado você perderá os itens cadastrados neste anexo!</p>
          <v-layout>
            <v-flex v-if="analyticalsOfBudget">
              <p>Selecione a Planilha que deseja vincular</p>
              <v-radio-group v-model="sheetBondId">
                <v-radio  v-for="item in analyticalsOfBudget" :key="item._id" :label="`${item.header.professionalCategory.occupation.name} ${item.header.additionalInfo} - ${item.header.deliveryAddress.sector}`" :value="item._id"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" class="mb-3" block outline round @click="confirmBond" :disabled="!sheetBondId">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.visible"
      :color="snackbar.color"
      multi-line
      :timeout="snackbar.timeout"
      vertical
      right
      button
    >
      <strong>{{snackbar.title}}</strong>
      <v-btn
        dark
        flat
        @click="snackbar.visible = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>

    <v-alert v-model="editingNotAllowed" color="warning" icon="priority_high" outline style="font-size: 18px !important" class="ma-5">
      <strong>A opção "Venda Variável" está selecionada para "{{filter}}"!</strong> <br />Por isso não é possível fazer alterações nesta área.
    </v-alert>
  </div>
</template>

<script>
  import AnalyticalWorksheetService from "../../service/AnalyticalWorksheetService.js";
  import Currency from '../../utils/Currency'
  import Headers from '../../data/headers/AttachmentHeaders'
  import ModuleFiveService from '../../service/ModuleFiveService';
  import ProductService from "../../service/ProductService.js";
  import SheetDefaultData from '../../data/sheet/SheetDefaultData'
  import {mapState} from "vuex";

  export default {
    name: "attachment",
    data: () => ({
      analyticalsOfBudget: [],
      bond: false,
      bonds: [],
      bondAlert: false,
      bondDialog: false,
      bondDialogTitle: "Vínculo de Anexo",
      bondSheet: {},
      bondSheetDescription: "",
      currency_config: Currency.real,
      // TIPO de CÁLCULO //
      depreciation: "false",
      removeDialog: false,
      removeDialogTitle: "Excluir Item",
      dialog: false,
      emptyRecordsText: "Nenhum registro encontrado",
      emptySearchText: "Nenhuma registro encontrado para",
      headers: [],
      index: -1,
      inputRules: [
        v => !!v || 'Campo obrigatório',
      ],
      isEditing: false,
      loading: false,
      loadingRecordsText: "Carregando registros...",
      search: "",
      sheetBondId: null,
      show: false,
      selectedItems: [],
      snackbar: {
        visible: false,
        title: "",
        color: "",
        timeout: 6000
      },
      input: {},
      filteredInputs: [],
      unbondDialog: false,
      validForm: true,
    }),
    props:{
      attachment: String,
      filter: String,
      inputsVariables: Object
    },
    computed: {
      amountMonthly() {
        let amount = ModuleFiveService.getAmountMonthly(this.selectedItems, this.depreciation)
              
        return amount
      },
      amountMonthlyByEmployee() {
        let amount = ModuleFiveService.getAmountMonthlyByEmployee(this.attachment, this.amountMonthly, this.numberOfEmployees)
        
        this.$store.commit(`SET_AMOUNT_OF_${this.attachment.toUpperCase()}_BY_MONTH`, {value: amount, employees: this.numberOfEmployees});
        return amount
      },
      editingNotAllowed(){
        return this.inputsVariables && this.inputsVariables[this.attachment].has ? true : false
      },
      footerDynamicText() {
        return this.loading ? this.loadingRecordsText : this.emptyRecordsText
      },
      formTitle() {
        return this.isEditing ? "Editar Item" : "Novo Item";
      },
      hasBond(){
        if(!this.bonds)
          return
        for (let i = 0; i < this.bonds.length; i++) {
          if(this.bonds[i].moduleFive && this.bonds[i].moduleFive[this.attachment].bond===this.analyticalWorksheet._id)
            return true
        }
        return false
      },
      informations(){
        let informations = new Array()

        informations.push(
          {
            class: `xs12 ${this.attachment === 'uniformsAndEPIs' ? 'md6' : 'md4'}`,
            title: "Sub-Total",
            subtitle: "",
            value: this.subTotalOfAttachment
          },
        )
        if(this.attachment != 'uniformsAndEPIs'){
          informations.push(
            {
              class: "xs12 md4",
              title: "Total Mensal Estimado",
              subtitle: "",
              value: this.amountMonthly
            },
          )
        }
        
        informations.push(
          {
            show: true,
            class: `xs12 ${this.attachment === 'uniformsAndEPIs' ? 'md6' : 'md4'}`,
            title: "Total Mensal por Empregado",
            subtitle: this.attachment != 'uniformsAndEPIs' ? `Total de Empregados: ${this.numberOfEmployees}` : "",
            value: this.amountMonthlyByEmployee
          }
        )
        return informations
      },
      labelDepreciation(){
        if(this.depreciation=="false")
          return "Vida Útil (mês)"
        
        return "Taxa de Depreciação (%)"
      },
      moduleFive(){        
        if(this.analyticalWorksheet.moduleFive)
          return this.analyticalWorksheet.moduleFive
        
        return SheetDefaultData.getModuleFive()
      },
      numberOfEmployees(){
        return ModuleFiveService.getNumberOfEmployees(this.bonds)
      },
      subTotalOfAttachment() {
        return ModuleFiveService.getSubTotalOfAttachment(this.selectedItems)
      },
      ...mapState({analyticalWorksheet: state => state.budget.analyticalWorksheet}),
      ...mapState({budgetFinalized: state => state.budget.budgetFinalized}),
    },

    async created() {
      this.depreciation = "false",
      this.bonds = await this.getBonds()
      this.initialize();
    },
    async beforeMount() {
      await this.getHeaders()
    },
    methods: {
      amountCalculate(item){
        return ModuleFiveService.amountCalculate(item, this.depreciation)
      },
      checkDuplicateRecord() {
        if (this.selectedItems.length > 0) {
          for (const inp of this.selectedItems) {
            if (inp._id == this.input._id) return false;
          }
        }
        return true;
      },
      async confirmBond(){
        this.bonds = new Array()
        this.moduleFive[this.attachment].items = new Array()
        this.moduleFive[this.attachment].bond = this.sheetBondId
        try {
          let savedSheet = await AnalyticalWorksheetService.edit(this.analyticalWorksheet)
          await this.$store.commit("SET_ANALYTICAL_WORKSHEET", savedSheet.dataEdited);
          this.bonds = await this.getBonds()
        } catch (error) {
          console.log(error)
        } finally{
          this.bondDialog = false
          this.sheetBondId = ""
        }
      },
      async deleteItem() {
        if (this.loading || this.budgetFinalized) return;
        try {
          this.loading = true;
          this.selectedItems.splice(this.selectedItems.indexOf(this.input), 1);
          this.showAlert("Item excluído com sucesso!!!", "success");
        } catch (error) {
          this.showAlert("Erro ao excluir este item!!!", "error");
          console.log(error);
        } finally {
          this.loading = false;
          this.removeDialog = false;
          this.initialize();
          this.$refs.form.resetValidation()
        }
      },
      async editItem(item) {
        if (this.loading) return;
        try {
          this.loading = true;
          this.isEditing = true;
          this.show = true
          this.index = this.selectedItems.indexOf(item);
          this.input = this.selectedItems[this.selectedItems.indexOf(item)];
          this.dialog = true;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },
      async getBonds(){
        let sheetBondId = this.moduleFive[this.attachment].bond ? this.moduleFive[this.attachment].bond : this.analyticalWorksheet._id
        
        return await AnalyticalWorksheetService.getBonds(sheetBondId, this.attachment)
      },
      getHeaders() {
        this.headers = Headers.getHeaders();
      },
      getSelectedItems(){
        if(!this.bonds)
          return new Array()

        this.depreciation = this.moduleFive[this.attachment].depreciation.toString()
        
        this.bondAlert = false
        let selectedItems  = new Array()
        for (let i = 0; i < this.bonds.length; i++) {
          if(!this.bonds[i].moduleFive)
            continue
          if(this.bonds[i].moduleFive[this.attachment].items.length > 0){
            selectedItems = this.bonds[i].moduleFive[this.attachment].items
            if(this.bonds[i]._id != this.analyticalWorksheet._id){
              this.bondSheetDescription = `${this.bonds[i].header.professionalCategory.occupation.name} ${this.bonds[i].header.additionalInfo} - ${this.bonds[i].header.deliveryAddress.sector}`
              this.bondAlert = true
            }
          }
        }
        return selectedItems
      },
      async initialize() {
        this.loading = true;
        try {
          this.input = Object.assign({});
          this.filteredInputs = await ProductService.getByCategory({
            type: this.filter
          });
          this.isEditing = false
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },
      async openBondDialog(){
        try {
          this.analyticalsOfBudget = new Array()

          let sheets = await AnalyticalWorksheetService.findByBudgetId(this.analyticalWorksheet.budget);
          for( var i = 0; i < sheets.length; i++){
            if ( sheets[i]._id === this.analyticalWorksheet._id) {
              continue
            } else if ( sheets[i].moduleFive && sheets[i].moduleFive[this.attachment] && sheets[i].moduleFive[this.attachment].bond) {
              continue
            } else if ( sheets[i].header.unitOfMeasurement != this.analyticalWorksheet.header.unitOfMeasurement) {
              continue
            }
            this.analyticalsOfBudget.push(sheets[i])
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.bondDialog = true
        }
      },
      openRemoveDialog(item) {
        this.input = item;
        this.removeDialog = true;
      },
      async save() {
        if(this.budgetFinalized)
          return
        if (!this.$refs.form.validate()) return;
        if (this.loading) return;
        this.loading = true;
        let type = "success"
        let message = ""
        try {
          if (this.isEditing) {
            this.loading = true;
            this.selectedItems[this.index] = this.input;
            message = "Item alterado com sucesso";
          } else {
            if (this.checkDuplicateRecord()) {
              this.selectedItems.push(this.input);
              message = "Item salvo com sucesso";
            } else {
              message = "Item já adicionado";
              type = "warning"
            }
          }
          this.showAlert(message, type);
          this.loading = true;
        } catch (error) {
          this.showAlert("Erro ao salvar este item", "error");
          console.log(error);
        } finally {
          this.dialog = false;
          this.initialize();
          this.loading = false;
          this.input = {}
          this.$refs.form.resetValidation()
        }
      },
      async setSheetModuleFive() {
        let sheet = this.$store.getters.getAnalyticalWorksheet
        if(sheet.moduleFive != this.moduleFive){
          sheet.moduleFive = Object.assign({}, this.moduleFive)
          await this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);
        }
      }, // setSheetModuleFive() //
      showAlert(message, color) {
        this.snackbar.title = message;
        this.snackbar.color = color;
        this.snackbar.visible = true;
      }, //showAlert()
      textDescription: item => `${item.description} - ${item.stamp} - ${item.unity}`,
      async unbond(){
        this.moduleFive[this.attachment].items = new Array()
        this.moduleFive[this.attachment].bond = null
        try {
          let savedSheet = await AnalyticalWorksheetService.edit(this.analyticalWorksheet)
          await this.$store.commit("SET_ANALYTICAL_WORKSHEET", savedSheet.dataEdited);
          this.bonds = await this.getBonds()
        } catch (error) {
          console.log(error)
        } finally{
          this.unbondDialog = false
          this.bondAlert = false
        }
      },
    },
    watch:{
      bonds: {
        handler: function() {
          if(!this.bonds)
            this.selectedItems = []

          this.selectedItems = this.getSelectedItems()
          
        },
        deep: true
      },
      depreciation: {
        handler: function() {
          this.headers[5].text = this.depreciation == "true" ? "Taxa de Depreciação (%)" : "Vida Útil (mês)"
          this.moduleFive[this.attachment].depreciation = this.depreciation
        },
        deep: true
      },
      moduleFive: {
        handler: function() {
          this.setSheetModuleFive()
        },
        deep: true
      },
      selectedItems: {
        handler: function() {
          if(!this.moduleFive[this.attachment].bond)
            this.moduleFive[this.attachment].items = this.selectedItems
        },
        deep: true
      }
    }
  };

</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/budget/Attachment.vue